// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconGift = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
            <path
                fill="#FFF"
                d="M0.875000417,13.1250006 C0.875000417,13.6089853 1.26628941,14.0000006 1.75000042,14.0000006 L6.12500042,14.0000006 L6.12500042,7.87500059 L0.875000417,7.87500059 L0.875000417,13.1250006 Z M13.1250004,3.50000029 L11.9727344,3.50000029 C12.2997654,2.8732823 12.3831643,2.11777436 11.9716404,1.2742195 C11.577344,0.464570631 10.7351568,-0.000425826002 9.83007854,2.92611927e-07 C8.68711013,0.000426997255 7.94882888,0.582969536 7,1.86757838 C6.05117238,0.582969536 5.31289113,0.000426997255 4.16992229,2.92611927e-07 C3.264844,-0.000425826002 2.42320341,0.464570631 2.02835959,1.2742195 C1.61683607,2.11777436 1.70023459,2.87382888 2.02753931,3.50000029 L0.875,3.50000029 C0.391835988,3.50000029 0,3.89183699 0,4.37500059 L0,6.12500059 C0,6.60625075 0.393749833,6.99918031 0.850390375,6.99918031 L13.1003904,6.99918031 C13.5816405,6.99918031 13.9753904,6.60625075 13.9753904,6.12500059 L13.9753904,4.37500059 C14,3.89101588 13.6089843,3.50000029 13.1249996,3.50000029 L13.1250004,3.50000029 Z M4.20820254,3.50000059 C3.6041792,3.50000059 3.11445254,3.01027392 3.11445254,2.40625059 C3.11445254,1.80222725 3.6041792,1.31250059 4.20820254,1.31250059 C4.75234342,1.31250059 5.15429646,1.40273463 6.56249958,3.50000059 L4.20820254,3.50000059 Z M9.79179662,3.50000059 L7.43749958,3.50000059 C8.84570271,1.40273463 9.24738246,1.31250059 9.79152292,1.31250059 C10.3955463,1.31250059 10.8852729,1.80222725 10.8852729,2.40625059 C10.8852729,3.01027392 10.3960937,3.50000059 9.79179662,3.50000059 Z M7.87499958,14.0000006 L12.2499996,14.0000006 C12.7337106,14.0000006 13.1249996,13.6089853 13.1249996,13.1250006 L13.1249996,7.87500059 L7.89960629,7.87500059 L7.87499958,14.0000006 Z"
                opacity=".66"
                transform="translate(0 .75)"
            />
        </svg>
    );
};

export default IconGift;
